import React, {FC} from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {Text} from 'wix-ui-tpa/cssVars'
import type {CancellationPolicy} from '@wix/ambassador-table-reservations-v1-reservation-location/types'

import {classes} from './Form.st.css'

interface CancellationPolicyDisclosureProps {
  cancellationPolicy: CancellationPolicy | undefined | null
}

/**
 * Displays the merchant-authored guest policy text before the guest submits their reservation.
 * Only rendered when the location has an active cancellation fee configured (config-driven,
 * never gated on the tableReservationsCancellationFee experiment flag).
 */
export const CancellationPolicyDisclosure: FC<CancellationPolicyDisclosureProps> = ({
  cancellationPolicy,
}) => {
  const {t} = useTranslation()

  if (!cancellationPolicy?.cancellationFee) {
    return null
  }

  return (
    <div className={classes.cancellationPolicyDisclosure}>
      <Text className={classes.cancellationPolicyTitle} tagName="p">
        {t('uou-reservations.reservation-details.cancellation-policy.title')}
      </Text>
      {cancellationPolicy.guestPolicy ? (
        <Text className={classes.cancellationPolicyText} tagName="p">
          {cancellationPolicy.guestPolicy}
        </Text>
      ) : null}
    </div>
  )
}
